"use client";

import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@base-ui/react/checkbox";
import type React from "react";
import { cn } from "@/lib/utils";
function CheckIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg aria-hidden="true" className="size-3 stroke-white" fill="none" height="8" viewBox="0 0 10 8" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M1 4L3.5 6.5L9 1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
type StyledCheckboxProps = React.ComponentPropsWithoutRef<typeof Checkbox.Root> & {
  ref?: React.Ref<React.ComponentRef<typeof Checkbox.Root>>;
};
function StyledCheckbox(t0) {
  const $ = _c(11);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("peer relative flex size-5 shrink-0 items-center justify-center rounded-md border border-gray-400 bg-preview-bg transition-transform duration-200 ease-in-out will-change-transform active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-50 data-checked:border-sky-400 data-checked:bg-sky-400", "after:absolute after:-inset-3 after:content-['']", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Checkbox.Indicator className="flex items-center justify-center text-current"><CheckIcon /></Checkbox.Indicator>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== t1) {
    t3 = <Checkbox.Root className={t1} ref={ref} {...props}>{t2}</Checkbox.Root>;
    $[7] = props;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export { StyledCheckbox as Checkbox };